<kendo-dialog title="{{'_Report_Filter_Delete_Template_Popup_Title_' | translate}}" *ngIf="dialogOpened" [minWidth]="300" [width]="500"
  (close)="close()">
  <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>

  <div>{{'_Report_Filters_Delete_Popup_Description_Text_' | translate : { value0: templateName} }}</div>

  <kendo-dialog-actions class="cc-btn-panel">
    <button id="deleteFilterTmpNoBtn" class="btn btn-secondary" (click)="clickCancel()">{{'_General_Action_Label_No_Text_' | translate }}</button>
    <button id="deleteFilterTmpYesBtn" class="btn btn-primary" (click)="clickContinue()" [disabled]="false">{{'_General_Action_Label_Yes_Text_' | translate }}</button>
  </kendo-dialog-actions>
</kendo-dialog>
